<template>
  <span>
    <span v-if="!isConfirmed" class="badge badge-secondary active-tag">
      <font-awesome-icon icon="question" />
    </span>
    <span v-else-if="isActive" class="badge badge-success active-tag">
      <font-awesome-icon icon="check" />
    </span>
    <span v-else class="badge badge-danger active-tag">
      <font-awesome-icon icon="times" />
    </span>
  </span>
</template>

<script>
export default {
  name: "ActiveTag",
  props: {
    isActive: Boolean,
    isConfirmed: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.active-tag {
  width: 19px;
  margin-left: 7px;
}
</style>